import { cx } from './cx.ts';
import m from './Motifs.module.css';
import s from './SectionHeader.module.css';
import t from './type.module.css';

/** Splits "Day 06 / 10" into words and numeral runs, so the numerals can use the readout face. */
export function withNumerals(text: string) {
  return text.split(/(\d(?:[\d\s/.:·–-]*\d)?)/).map((part, i) =>
    i % 2 === 1 ? (
      // biome-ignore lint/suspicious/noArrayIndexKey: the parts of a fixed string never reorder
      <span key={i} className={t.numerals}>
        {part}
      </span>
    ) : (
      part
    ),
  );
}

/**
 * C-01 Section header (docs/design/components/C-01-section-header.md). The kicker is rationed:
 * only real context that differs from the title (craft rule 3). Bracketed titles are user content
 * (a trip name) and keep their own case in the text face.
 */
export function SectionHeader({
  title,
  kicker,
  readout,
  variant = 'section',
  bracketed = false,
  stripe = false,
  level = variant === 'screen' ? 1 : 2,
}: {
  title: string;
  kicker?: string;
  readout?: string;
  variant?: 'screen' | 'section';
  bracketed?: boolean;
  /** The calibration tag then a hairline, once a screen (S-01, S-03, W-01 to W-03). */
  stripe?: boolean;
  level?: 1 | 2 | 3;
}) {
  const Heading = `h${level}` as const;
  return (
    <header className={s.header}>
      {kicker && <div className={cx(s.kicker, t.displayS)}>{kicker}</div>}
      <div className={s.row}>
        {bracketed ? (
          <Heading className={cx(s.title, t.titleL)}>
            <span className={s.bracket} aria-hidden="true">
              [
            </span>
            {title}
            <span className={s.bracket} aria-hidden="true">
              ]
            </span>
          </Heading>
        ) : (
          <Heading className={cx(s.title, variant === 'screen' ? t.displayXL : t.displayL)}>
            {withNumerals(title)}
          </Heading>
        )}
        {readout && (
          <span
            className={cx(variant === 'screen' ? t.readoutM : t.readoutS, variant !== 'screen' && s.quiet)}
          >
            {readout}
          </span>
        )}
      </div>
      {stripe && (
        <div className={s.rule}>
          {/* The calibration stripe tag leads the rule (M-09). */}
          <span className={cx(m.calibration, s.stripeTag)} aria-hidden="true" />
          <hr className={m.hairline} />
        </div>
      )}
    </header>
  );
}
